export default {
    title: 'Pripravujem',
    newFunction:{
        one: 'funkcia “Drag and drop“ node v JSON Tree',
        two: 'hierarchické zobrazenie pri fulltextovom vyhľadávaní property alebo value'
    },
    newFeature: 'Myslíš že tu niečo chýba alebo máš nápad na vylepšenie? Neváhaj ma kontaktovať <strong><a href="mailto:jxformatter@gmail.com">jxformatter@gmail.com</a></strong>'
}
